import { render } from "./IconCard.vue?vue&type=template&id=53bcab11&scoped=true"
const script = {}

import "./IconCard.vue?vue&type=style&index=0&id=53bcab11&lang=css&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bcab11"]])

export default __exports__